import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Filter from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TableSizePopup from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import { DeletePopup } from "../../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import { SeatingStatus } from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";

class FilterSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPagination: 1,
      displayGrid: false,
      displayDropDown: false,
      allDinerDetails: [],
      displayMobileSearch: false,
      displaySearch: false,
      open: false,
      openDefaultWaitTime: false,
      openPax: false,
      selectedPage: 1,
      showStatus: "All",
      showStatusText: "",
      defaultWaitTime: "00-05",
      showPax: "All",
      showPaxText: "",
      search: "",
    };
  }
  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };
  onNextHoursOpen = (e) => {
    this.setState({
      displayDropDown: !this.state.displayDropDown,
    });
  };

  /****************************************
   * @DESC Ope Modal
   ***************************************/
  onOpenModal = (id) => {
    this.setState({ open: id });
  };
  onCloseModal = () => {
    this.setState({ open: 0 });
  };
  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };

  /**************************************
   * @DESC Big Button Show Status Handler
   ***************************************/
  bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showStatusText: type,
    });
  };
  selectStatusClick = (e) => {
    this.setState({
      showStatus:
        this.state.showStatusText === "" ? "All" : this.state.showStatusText,
      open: false,
    });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPaxText: type,
    });
  };
  selectPaxClick = (e) => {
    console.log("hi");
    this.setState({
      showPax: this.state.showPaxText === "" ? "All" : this.state.showPaxText,
      openPax: false,
    });
  };

  searchButton = (e) => {
    e.preventDefault();
    this.setState({
      displaySearch: true,
    });
  };

  searchButtonClose = (e) => {
    e.preventDefault();
    this.setState({ displaySearch: false });
  };

  searchButtonMobile = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: true,
    });
  };

  searchButtonMobileClose = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: false,
    });
  };

  onChangePagination = (page) => {
    this.setState({
      currentPagination: page,
    });
  };

  render() {
    const { search, displayGrid } = this.state;

    return (
      <React.Fragment>
        <Row className="container-fluid">
          <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 seating-topbar-search">
            <div className="filter-button">
              <Filter origin={"events"} />
            </div>
            <div className="filter-button-border-left"></div>
            <div className="filter-button-search">
              {/* <Form.Control
                    type="text"
                    placeholder="Search"
                    onChange={this.onSearchChange}
                    value={this.state.search}
                    className="amSearch"
                  /> */}
              <Paper component="form" className="enSearch2 d-flex">
                <IconButton type="submit" aria-label="search">
                  <SearchIcon />
                </IconButton>
                <InputBase
                  placeholder="Search"
                  className="w-100"
                  inputProps={{
                    "aria-label": "Search by Name or Phone Number",
                  }}
                  onChange={this.onSearchChange}
                  value={this.state.search}
                />
              </Paper>
            </div>
            <div className="filter-button-qrcode">
              <div className="filter-button-qrcode-box">
                <img
                  src={require("../../../../../assets/images/ActionImages/image/qrcode.svg")}
                  className="img-fluid"
                  alt="QR Scan"
                  title="QR Scan"
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <div className="row">
              <div className="col-5 col-sm-5 col-md-4 col-lg-4 ">
                <SeatingStatus
                  status={this.state.showStatus}
                  onOpenModal={this.onOpenModal}
                  onCloseModal={this.onCloseModal}
                  open={this.state.open}
                  eventsMoreOptions={
                    this.props.pathname === "/offline-events-details"
                      ? true
                      : false
                  }
                  //   seatingStatus={this.state.showStatusText}
                  //   onClickAll={(e) => this.bigButtonShowStatusHandler(e, "All")}
                  //   onClickSeated={(e) =>
                  //     this.bigButtonShowStatusHandler(e, "Seated")
                  //   }
                  //   onClickNonSeated={(e) =>
                  //     this.bigButtonShowStatusHandler(e, "Not Seated")
                  //   }
                  //   onStatusClick={this.selectStatusClick}
                />
              </div>
              <div className="col-4 col-sm-4 col-md-4 col-lg-4 ">
                {/* <SetWaitTime 
                
                  _id={"5f8ac1f8c0aac52d42af60a8"}
                 /> */}
              </div>
              <div className="col-3 col-sm-3 col-md-4 col-lg-4">
                <TableSizePopup
                  showPax={this.state.showPax}
                  onOpenModal={this.onOpenModalPax}
                  open={this.state.openPax}
                  onCloseModal={this.onCloseModalPax}
                  //   table_size={this.state.showPaxText}
                  //   onClickAll={(e) => this.bigButtonShowPaxHandler(e, "All")}
                  //   onClickTwo={(e) => this.bigButtonShowPaxHandler(e, "2")}
                  //   onClickFour={(e) => this.bigButtonShowPaxHandler(e, "4")}
                  //   onClickSix={(e) => this.bigButtonShowPaxHandler(e, "6")}
                  //   onClickEight={(e) => this.bigButtonShowPaxHandler(e, "8")}
                  //   graterThanEight={(e) => this.bigButtonShowPaxHandler(e, "8>")}
                  //   selectPaxClick={this.selectPaxClick}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 right-side-seating mobile-d-flex mobile-justify-content-between ">
            {this.props.pathname !== "/offline-events-pending" &&
              this.props.pathname !== "/offline-events-booked" && (
                <div className="complete_record_image">
                  <DeletePopup
                    display={true}
                    displayPopup="completedRecord"
                    buttonDisplay="completedRecord"
                    buttonText="Complete Record"
                    bigText="Are you sure to Complete All Seated Records ?"
                  />
                  <p className="complete_record_small_text">
                    Mark Seated as Complete
                  </p>
                </div>
              )}
            <div className="btn-group" role="group" aria-label="Basic example">
              <button
                type="button"
                className={
                  displayGrid
                    ? "btn grid-button-group"
                    : "btn grid-button-group grid-button-group-active"
                }
                onClick={this.onGridViewOpen}
              >
                <img
                  src={require("../../../../../assets/images/ActionImages/image/grid.svg")}
                  className="img-fluid"
                  alt="table"
                  title="table"
                />
              </button>
              <button
                type="button"
                className={
                  displayGrid
                    ? "btn grid-button-group grid-button-group-active"
                    : "btn grid-button-group"
                }
                onClick={this.onGridViewOpen}
              >
                <img
                  src={require("../../../../../assets/images/ActionImages/image/table.svg")}
                  className="img-fluid"
                  alt="table"
                  title="table"
                />
              </button>
            </div>
          </div>
        </Row>
      </React.Fragment>
    );
  }
}

export default FilterSection;
